import { useSelector } from 'react-redux';
import useSWRImmutable from 'swr/immutable';
import settings from '/@/core/settings';
import { axFetch } from '/@/store/session/actions';
import { getAppInstance } from '/@/store/session/selectors';

export interface UserUIAlertAndModalItem {
    id: number;
    alertTitle: string | null;
    alertSeverity: 'blue' | 'danger' | null;
    modalTitle: string | null;
    modalDescription: string | null;
}

export const USER_UI_ALERT_AND_MODAL_SWR_KEY = 'user-ui-alert-and-modal';

export async function fetchUserUIAlertAndModal(appInstanceId: number): Promise<UserUIAlertAndModalItem[]> {
    // biome-ignore lint/suspicious/noExplicitAny: settings.urls comes from JSON bootstrap like other hooks
    const apiDomain = (settings as any).urls.apiDomain as string;
    const url = new URL(`${apiDomain}/core/v1/ui/user-ui-alert-and-modal/`, window.location.origin);
    url.searchParams.set('app_instance', String(appInstanceId));
    const res = await axFetch.get<UserUIAlertAndModalItem[]>(url.toString());
    return res.data;
}

/** Loads tenant alert/modal copy for the current session app instance (always sends `app_instance`). */
export function useUserUIAlertAndModal({ enabled = true }: { enabled?: boolean } = {}) {
    const appInstance = useSelector(getAppInstance);
    const appInstanceId = appInstance?.id;
    const swrKey =
        enabled && appInstanceId != null ? ([USER_UI_ALERT_AND_MODAL_SWR_KEY, appInstanceId] as const) : null;

    return useSWRImmutable(swrKey, ([, id]: readonly [string, number]) => fetchUserUIAlertAndModal(id));
}
